import React from 'react';

const FileUploadIcon = ({ img }) => {
    const getTextContent = () => {
        if (img?.type.includes('pdf')) return 'PDF';
        if (img?.type.includes('document')) return 'DOC';
        if (img?.type.includes('plain')) return 'TXT';
        if (img?.type.includes('csv')) return 'CSV';
        return 'DOC'; // Fallback if none of the above conditions match
    };

    return (
        <>
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 708 800">
                <path
                    d="M275.62 185.77H159.518c-17.896 0-32.405 14.509-32.405 32.405 0 17.895 14.509 32.404 32.405 32.404H275.62c17.896 0 32.405-14.509 32.405-32.404 0-17.896-14.509-32.405-32.405-32.405Zm0 134.66H159.518c-17.896 0-32.405 14.508-32.405 32.404 0 17.896 14.509 32.405 32.405 32.405H275.62c17.896 0 32.405-14.509 32.405-32.405s-14.509-32.404-32.405-32.404Zm136.24 226.889v31.558h16.671c20.218 0 20.219-12.096 20.219-16.071 0-3.834-.001-15.489-20.219-15.489H411.86v.002Z"
                    fill="#020202"
                />
                <path
                    d="M657.994 487.691h-52.733V159.22c0-8.498-3.37-16.645-9.384-22.648L468.687 9.374C462.678 3.37202 454.532.00052 446.039 0H63.2669C28.5879 0 .3789 28.211.3789 62.89v674.217c0 34.682 28.211 62.893 62.888 62.893H542.371c34.677 0 62.888-28.213 62.888-62.893v-64.912h52.733c27.407 0 49.628-22.219 49.628-49.629v-85.249c.002-27.406-22.218-49.626-49.626-49.626ZM536.966 729.976H68.6719V70.024H401.548v94.137c0 22.802 18.479 41.276 41.272 41.276h94.146v282.254H376.719c-27.409 0-49.628 22.22-49.628 49.628v85.25c0 27.409 22.219 49.628 49.628 49.628h160.247v57.779Z"
                    fill="#020202"
                />
                <path
                    d="M520.656 547.319h-21.177v60.017h21.177c17.099 0 31.011-13.441 31.011-29.946.002-16.582-13.91-30.071-31.011-30.071Z"
                    fill="#020202"
                />
                <path fill="#020202" d="M345 518h346v122H345z" />
                <text
                    x="518"
                    y="590"
                    fill="white"
                    fontSize="130"
                    fontWeight="bold"
                    textAnchor="middle"
                    dominantBaseline="middle"
                >
                    {getTextContent()}
                </text>
            </svg>
            <small>{img.name}</small>
        </>
    );
};

export default FileUploadIcon;
